import React, { FC } from 'react';
import { Box, Text, Button, FormControl, TextField, TextFieldSize, ButtonAppearance } from '@bechtel/gds';
import { AddVaultCotainerStyled } from './styled';
import { Trans, t } from '@lingui/macro';
import { Formik } from 'formik';
import { object, string, number } from 'yup';
import { AddNewDataVaultProps, AddVaultFormikState } from './types';

const initialValues: AddVaultFormikState = {
  name: '',
  description: '',
  latitude: undefined,
  longitude: undefined,
};

const addVaultValidationSchema = object().shape({
  name: string()
    .min(2, t`Too Short!`)
    .max(50, t`Too Long!`)
    .required(t`Name is mandatory`),
  description: string()
    .min(3, t`Too Short!`)
    .max(2000, t`Too Long!`),
  latitude: number().required(),
  longitude: number().required(),
});

export const AddNewDataVault: FC<AddNewDataVaultProps> = ({ close }) => {
  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      validationSchema={addVaultValidationSchema}
      onSubmit={(values) => {}}
    >
      {({ setFieldValue, values, dirty, isValid, handleSubmit }) => {
        return (
          <AddVaultCotainerStyled>
            <Box px={{ sm: '400' }}>
              <FormControl
                label={
                  <Text family="graphik" size="300" color="bechtel.blue.800">
                    <Trans>Name</Trans>
                  </Text>
                }
                css={`
                  flex-grow: 1;
                `}
              >
                <TextField
                  size={TextFieldSize.LARGE}
                  value={values.name}
                  placeholder={t`Name`}
                  onChange={(event) => {
                    setFieldValue('name', event.target.value);
                  }}
                />
              </FormControl>
            </Box>
            <Box px={{ sm: '400' }}>
              <FormControl
                label={
                  <Text family="graphik" size="300" color="bechtel.blue.800">
                    <Trans>Description</Trans>
                  </Text>
                }
                css={`
                  flex-grow: 1;
                `}
              >
                <TextField
                  size={TextFieldSize.LARGE}
                  value={values.description}
                  placeholder={t`Description`}
                  onChange={(event) => {
                    setFieldValue('description', event.target.value);
                  }}
                />
              </FormControl>
            </Box>
            <Box px={{ sm: '400' }}>
              <FormControl
                label={
                  <Text family="graphik" size="300" color="bechtel.blue.800">
                    <Trans>Latitude</Trans>
                  </Text>
                }
                css={`
                  flex-grow: 1;
                `}
              >
                <TextField
                  size={TextFieldSize.LARGE}
                  value={values.latitude}
                  placeholder={t`Latitude`}
                  onChange={(event) => {
                    setFieldValue('latitude', event.target.value);
                  }}
                />
              </FormControl>
            </Box>
            <Box px={{ sm: '400' }}>
              <FormControl
                label={
                  <Text family="graphik" size="300" color="bechtel.blue.800">
                    <Trans>Longitude</Trans>
                  </Text>
                }
                css={`
                  flex-grow: 1;
                `}
              >
                <TextField
                  size={TextFieldSize.LARGE}
                  value={values.longitude}
                  placeholder={t`Longitude`}
                  onChange={(event) => {
                    setFieldValue('longitude', event.target.value);
                  }}
                />
              </FormControl>
            </Box>

            <Box px={{ sm: '400' }} justifyContent={{ sm: 'space-between' }}>
              <Button appearance={ButtonAppearance.TERTIARY} onClick={close}>
                <Text family="graphikCompact" weight="600" size="400" color="bechtel.blue.800">
                  <Trans>Cancel</Trans>
                </Text>
              </Button>

              <Button
                appearance={ButtonAppearance.TERTIARY}
                disabled={!dirty || !isValid}
                onClick={() => handleSubmit()}
              >
                <Text family="graphikCompact" weight="600" size="400" color="bechtel.blue.800">
                  <Trans>Save</Trans>
                </Text>
              </Button>
            </Box>
          </AddVaultCotainerStyled>
        );
      }}
    </Formik>
  );
};
